import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AssetLandingPage } from './asset-landing';
import { AlertsComponent } from '../../components/alerts/alerts';
import { HealthComponent } from '../../components/health/health';
import { ReportsComponent } from '../../components/reports/reports';
import { TrendsComponent } from '../../components/trends/trends';
import { TrendsChartCard } from '../../components/trends/trends-components/trends-charts-card.component';
import { AlertTabCard } from '../../components/alerts/alert-components/alert-tab-card.component';
import { HealthTabComponent } from '../../components/health/health-components/health-tab.component';
import { NgCircleProgressModule } from 'ng-circle-progress'; 
import { TimelineComponent } from '../../components/timeline/timeline';
import { AssetService } from '../../services/asset.service';
import { ProjectService } from '../../services/project.service';
import { AlertService } from '../../services/alert.service';
import { HealthService } from '../../services/health.service';
import { SystemsComponent } from '../../components/systems/systems';
import { PointCategoriesComponent } from '../../components/point-categories/point-categories';
import { GetDataComponent } from '../../components/get-data/get-data';
import { PointsComponent } from '../../components/points/points';
import { PhysicalReadingsComponent } from '../../components/reports/physical-readings/physical-readings';
import { GridDataComponent } from '../../components/trends/trends-components/grid-data/grid-data';
import { ManualPointService } from '../../services/manual-point.service';
import { LogReportsPdf } from '../../templates/log-reports-pdf.component';
import { EmailDetailsComponent } from '../../components/reports/email-details/email-details.component';
import { CommentsDetailsComponent } from '../../components/reports/comments-details/comments-details.component';
import { MoreComponent } from '../../components/more/more.component';
// import {ToggleMenu} from "../..components/toggle-menu.component"
import { ToggleMenu } from "../../components/toggle-menu.component";
import { CommonPipesModule } from "../../pipes/common-pipes.module";
import { TranslateModule, TranslateLoader, TranslatePipe } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClientModule, HttpClient, } from "@angular/common/http";
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AssetLandingPage,
    AlertsComponent,
    HealthComponent,
    ReportsComponent,
    TrendsComponent,
    TrendsChartCard,
    AlertTabCard,
    HealthTabComponent,
    TimelineComponent,
    SystemsComponent,
    PointCategoriesComponent,
    GetDataComponent,
    PointsComponent,
    PhysicalReadingsComponent,
    GridDataComponent,
    LogReportsPdf,
    EmailDetailsComponent,
    MoreComponent,
    ToggleMenu,
    CommentsDetailsComponent

  ],
  imports: [
    IonicPageModule.forChild(AssetLandingPage),
    NgCircleProgressModule.forRoot({
      "radius": 30,
      "space": -10,
      "outerStrokeWidth": 10,
      "outerStrokeColor": "#4882c2",
      "innerStrokeColor": "#e7e8ea",
      "innerStrokeWidth": 10,
      "title": "15",
      "animateTitle": false,
      "animationDuration": 1000,
      "showUnits": false,
      "showBackground": false,
      "clockwise": true,
      }),
      TranslateModule.forRoot(),
      TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: (HttpLoaderFactory),
            deps: [HttpClient]
        }
    }),
  ],
  providers: [
    AssetService,
    ProjectService,
    AlertService,
    HealthService,
    ManualPointService
  ],
  entryComponents: [
    EmailDetailsComponent,
     CommentsDetailsComponent
  ]
})
export class AssetLandingPageModule {}




// WEBPACK FOOTER //
// ./src/pages/asset-landing/asset-landing.module.ts